<template>
  <div class="sidebar-item-container">
    <template v-for="item in routes" v-if="!item.hidden && item.children">
      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children"
                   :to="item.path + '/' + item.children[0].path"
                   :key="item.children[0].name">
        <el-menu-item :index="item.path + '/' + item.children[0].path">
          <svg-icon v-if="item.children[0].meta && item.children[0].meta.icon" :iconClass="item.children[0].meta.icon"/>
          <span v-if="item.children[0].meta && item.children[0].meta.title" slot="title">{{ item.children[0].meta.title }}</span>
        </el-menu-item>
      </router-link>
      <el-submenu v-else :index="item.name || item.meta.path" :key="item.name">
        <template slot="title">
          <svg-icon v-if="item.meta && item.meta.icon" :iconClass="item.meta.icon"/>
          <span v-if="item.meta && item.meta.title" slot="title">{{ item.meta.title }}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item :is-nested="true"
                        v-if="child.children && child.children.length > 0"
                        :routes="[child]"
                        :key="child.path"/>
          <router-link v-else :to="item.path + '/' + child.path" :key="child.name">
            <el-menu-item :index="item.path + '/' + child.path">
              <svg-icon v-if="child.meta && child.meta.icon" :iconClass="child.meta.icon"/>
              <span v-if="child.meta && child.meta.title" slot="title">{{ child.meta.title }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",

  props: {
    routes: {
      type: Array
    },

    isNested: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    hasOneShowingChildren(children) {
      if (children) {
        const showingChildren = children.filter(item => {
          return !item.hidden;
        });
        return showingChildren.length === 1;
      }
      return false;
    }
  }
}
</script>

<style scoped>
svg {
  font-size: 12px;
  margin: 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarItem/index.vue